import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { Button } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { ClockIcon, StatusBox } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type SwapProgressDrawerProps = {
  state: AsyncStateN.AsyncStateN<unknown, unknown>
  onClose?: () => void
  onContinue?: () => void
} & ClassNameProps

export const TransferProgress: React.FC<SwapProgressDrawerProps> = ({
  state,
  onClose,
  onContinue,
}) => {
  const { t } = useTranslation()

  const renderTitle = () => {
    if (AsyncStateN.isSuccess(state)) {
      return (
        <>
          <Title>{t('transfer.transfer-processing')}</Title>
          <Description>{t('transfer.transfer-processing-message')}</Description>
          <Button
            onClick={onContinue}
            variant="secondary"
            color="gray"
            radius="rounded"
          >
            {t('common.continue')}
          </Button>
        </>
      )
    }
    return (
      <>
        <Title $intent="error">{t('transfer.error')}</Title>
        <Description>{t('common.something_went_wrong_try_again')}</Description>
        <Button
          onClick={onClose}
          variant="secondary"
          color="gray"
          radius="rounded"
        >
          {t('common.close')}
        </Button>
      </>
    )
  }

  const renderBox = () => {
    if (AsyncStateN.isSuccess(state)) {
      return <StatusBox icon={ClockIcon} status={'loading'} />
    }
    return <StatusBox status={'error'} />
  }

  return (
    <Content>
      <StatusContainer>{renderBox()}</StatusContainer>
      {renderTitle()}
    </Content>
  )
}

const Content = styled.div`
  display: grid;
  padding-inline: 12px;
`

const StatusContainer = styled.div`
  display: grid;
  justify-items: center;
  margin-bottom: 12px;
`

const Title = styled.div<{ $intent?: 'success' | 'error' | undefined }>`
  text-align: center;
  color: ${({ $intent }) => {
    if ($intent === 'error') {
      return 'var(--error-9)'
    }
    if ($intent === 'success') {
      return 'var(--success-9)'
    }
    return 'var(--gray-12)'
  }};

  font-size: 16px;
  font-weight: 700;
  line-height: 20px;

  margin-bottom: 16px;
`

const Description = styled.div`
  color: var(--text-9);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 32px;
`
